import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigate } from '../modules/high_level_actions';
import { MAX_QUANTITY } from '../shared/cart';
import { addEnrollProductToCart, addProductToCart } from '../modules/cart_actions';
import { setDeclineBook } from '../modules/decline_box_book';
import { openDeclineModal } from '../modules/active_modal';

class CategoryItems extends Component {

  addToCartAction(oProduct, event) {
    let {isLoggedIn, customer, upgradeStatus, featured, store, dispatch } = this.props;
    let inStore = Boolean(oProduct.genres.find(g => g.store_id ? g.store_id === store.id : false));
    if( oProduct.large_print || oProduct.bluray ){
      let evt = {
        preventDefault: () => {/* noop */},
        currentTarget: { pathname: "/catalog/product/" + oProduct.id + '-' + oProduct.url }
      };
      dispatch(navigate(evt));
    } else if(isLoggedIn && customer.status === "Active" && !upgradeStatus){
      if(store.type === "Neglite" || !featured.find( x => x.id === oProduct.id && x.format === oProduct.format) || customer.current_cycle.response || !customer.current_cycle.active || !inStore)
        dispatch(addProductToCart(oProduct, 1 ));
      else
        dispatch([
          setDeclineBook(oProduct, 1),
          openDeclineModal()
        ]);
    } else
      dispatch(addEnrollProductToCart(oProduct, 1 ));
    event.stopPropagation();
    event.cancelBubble = true;
  }

  pidNavigate(pid , url, event) {
    let oEvent = {
      preventDefault: () => {/* noop */},
      currentTarget: {
        pathname: '/catalog/product/' + pid + '-' + url
      }
    }
    this.props.dispatch(navigate(oEvent));
    event.stopPropagation();
    event.cancelBubble = true;
  }

  render() {
    let aItems = this.props.products.map((oProduct, i) => {
      let showAddToCart = [], inCart = this.props.cartItems.length > 0 && this.props.cartItems.filter( c => c && c.id === oProduct.id ).length >= MAX_QUANTITY ,
        backorder_arrival_date = new Date(oProduct.backorder_arrival_date).getTime(),
        isAvailibleRegular = ( !isNaN(backorder_arrival_date) && backorder_arrival_date >= (Date.now()+ ( 1000 * 60 * 60 * 24 * 14)) && backorder_arrival_date >= Date.now() ) || oProduct.quantity_availible > 0;
      // 1 Normal physical book ( non-preorder and non-ebook)
      // 2 Normal Physical book that is also ebook (denoted by the quantity_availible being greater then 0 )
      if (oProduct.bundle_pricing && ( !oProduct.ebook || (oProduct.ebook && isAvailibleRegular ) )){
        if(!inCart)
          showAddToCart = (
            <button
              className = "btn-primary fat"
              name      = "book-added"
              onClick   = {this.addToCartAction.bind( this, { ...oProduct, format: 'regular' } )}
            >Add To Box</button>
          );
        else
          showAddToCart = (
            <button
                className = "btn-primary fat disabled"
                name      = "book-added"
                disabled  = "true"
            >In Box</button>
          );
      }

      if (oProduct && typeof oProduct === 'object') {
        return (
          <li key={'CategoryItem' + (oProduct && oProduct.mmid ? oProduct.mmid : i)}>
              <div className="onhover-actions" onClick={this.pidNavigate.bind( this, oProduct.id , oProduct.url ) }>
                <div className="button-group">
                  <a href={"/catalog/product/" + oProduct.id + '-' + oProduct.url}
                  onClick={(evt) => this.props.dispatch(navigate(evt))}
                  className="button btn-secondary fat">
                  Read More
                  </a>
                  {showAddToCart}
                </div>
              </div>
              <a href={"/catalog/product/" + oProduct.id + '-' + oProduct.url} onClick={(evt) => this.props.dispatch(navigate(evt))} >
                <img
                  className="product-scaled"
                  src={'//s3.amazonaws.com/bookspan-media/covers/full/' + oProduct.mmid + '.jpg'}
                />
            </a>
          </li>
        );
      } else {
        return '';
      }
    });

    return (
      <div className="product-list">
        <ul>
          {aItems}
        </ul>
      </div>
    );
  }
};

CategoryItems.defaultProps = {
  products: []
};

function mapStateToProps(state){
    return {
      'customer': state.customer,
      'isLoggedIn': state.isLoggedIn,
      'upgradeStatus': state.upgradeStatus,
      'store' : state.store,
      'featured' : state.featured,
      'cartItems': state.computedCart.items
    };
}

export default connect(mapStateToProps)(CategoryItems);


// WEBPACK FOOTER //
// ./src/components/CategoryItems.jsx